<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000145')"
					:inputValue="useYn"
					:options="useYnOptions"
					:onChange="value => onChange('useYn', value)"
				/>
			</el-col>
			<el-col :span="4">
				<sf-input-group
					:label="getMessage_('SWCC000733')"
					:inputValue="widgetMstFileId"
					:onChange="value => onChange('widgetMstFileId', value)"
				/>
			</el-col>
			<!-- <el-col :span="4">
				<sf-input-group :label="getMessage_('SWCC000224')" :inputValue="widgetTitle" :onChange="value => onChange('widgetTitle', value)" />
			</el-col> -->
		</el-row>
		<template slot="button">
			<sf-button line :v-if="isButton_(scrId, 'CR')" icon="search" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@common/WidgetMaster/store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	data() {
		return {
			screen: {},
			useYn: 'Y',
			widgetMstFileId: '',
			widgetTitle: '',
			pageInit: true
		};
	},

	computed: {
		...rootComputed,
		...serviceComputed
	},

	watch: {
		//화면 정보 로딩시
		screen() {
			if (this.pageInit && this.screen.defaultPageSize && this.user.plantCd) {
				//페이지 정보 초기화
				this.setState_({
					key: 'widgets',
					value: { currentPage: 1, pageUnit: this.screen.defaultPageSize, data: [] }
				})
					.then(() => {
						this.pageInit = false;

						this.setUseYnList(); //사용 유무 공통 코드 selectBox option을 위한 리스트 조회
						this.search(); //위젯 조회
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					});
			}
		}
	},

	methods: {
		...serviceMethods,

		onChange(key, value) {
			this[key] = value;
			if (key === 'useYn') {
				this.search();
			}
		},

		async setUseYnList() {
			this.$sf_toggleLoading(true);
			await this.getUseYnList_()
				.then(header => {
					//api 응답이 비정상일 경우만 알림 처리
					if (header.code !== 0) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//위젯 조회 Action 호출
		async search() {
			this.$sf_toggleLoading(true);
			await this.select_({
				useYn: this.useYn,
				widgetMstFileId: this.widgetMstFileId,
				widgetTitle: this.widgetTitle,
				currentPage: 1,
				pageUnit: this.widgets.pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
